import { put, select, takeLatest, debounce } from "redux-saga/effects";
import { tableAction, tableActions, tableInitialState } from "../../App/Ducks/Table.duck";
import { clearConnectionTasks, getConnectionTasks } from "../Services/ConnectionService";
import { MESSAGE_SEVERITY_ERROR } from "app/common/constants";
import { actions as AppActions } from "../../App/Ducks/App.duck";
export const actionTypes = {
  RequestData: "[Tasks] Request",
  FulfilledTable: "[Tasks] Fulfilled",
  SearchTable: "[Tasks] Search",
  ChangePage: "[Tasks] change page",
  SetPageSize: "[Tasks] set page size",
  SortTable: "[Tasks] Sort",
  ApplyFilter: "[Tasks] Apply filter",
  RemoveFilter: "[Tasks] Remove filter",
  SetConnectionId: "[Tasks] Set connection Id",
  ClearTasks: "[Tasks] Clear tasks"
};
const initialState = {
  ...tableInitialState,
  connectionId: null,
  clearingTasks: false
};
export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action, initialState);
  switch (action.type) {
    case actionTypes.SetConnectionId: {
      return {
        ...state,
        connectionId: action.connectionId
      };
    }
    case actionTypes.ClearTasks: {
      return {
        ...state
      };
    }
    default:
      return newState;
  }
};
export const actions = {
  ...tableActions(actionTypes),
  setConnectionId: (connectionId) => ({
    type: actionTypes.SetConnectionId,
    connectionId
  }),
  clearTasks: (connectionId, force) => ({
    type: actionTypes.ClearTasks,
    connectionId,
    force
  })
};
export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }
  yield debounce(500, actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);
  yield takeLatest(actionTypes.ClearTasks, function* clear(action) {
    const currentState = yield select((state) => {
      return state.TasksReducer;
    });
    currentState.clearingTasks = true;
    try {
      yield clearConnectionTasks(action.connectionId, action.force);
      yield put(actions.requestData(action.connectionId));
    } catch (error) {
      const severity = MESSAGE_SEVERITY_ERROR;
      const details = {
        method: "clearTasks",
        severity
      };
      yield put(AppActions.displayMessage(details));
    }
  });
  yield takeLatest(actionTypes.RequestData, function* request() {
    try {
      const currentState = yield select((state) => {
        return state.TasksReducer;
      });
      currentState.clearingTasks = false;
      const response = yield getConnectionTasks(
        currentState.connectionId,
        currentState.page,
        currentState.pageSize,
        currentState.sortBy,
        currentState.filters,
        currentState.searchQuery
      );
      yield put(actions.fulfilled(response.data["hydra:member"], response.data["hydra:totalItems"]));
    } catch (error) {
      const severity = MESSAGE_SEVERITY_ERROR;
      const details = {
        method: "getTasks",
        severity
      };
      yield put(AppActions.displayMessage(details));
    }
  });
}
